import { createFileRoute, redirect } from "@tanstack/react-router";
import { PageShell } from "../../components/PageShell";
import { CmeFeedbackScreen } from "./CmeFeedbackScreen";
import { missingDateDefault, parseCmeFeedbackSearch } from "./lib";

// The page's route. Discovered by vite.config.ts because it sits in a page
// folder; PageShell applies the page's flag gate and header.
function CmeFeedbackRoute() {
  return (
    <PageShell>
      <CmeFeedbackScreen />
    </PageShell>
  );
}

export const Route = createFileRoute("/_app/cme-feedback")({
  validateSearch: (search) => parseCmeFeedbackSearch(search),
  // Open on today. The date is written into the URL (replacing the history
  // entry, so Back doesn't bounce) so the page stays shareable as it is.
  beforeLoad: ({ search }) => {
    const today = missingDateDefault(search.date);
    if (today) {
      throw redirect({
        to: "/cme-feedback",
        search: { ...search, date: today },
        replace: true,
      });
    }
  },
  component: CmeFeedbackRoute,
});
